import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';
import { setBooking } from './update';

const fetchPromoCodeStarted = createAction('booking/fetchPromoCodeStarted');
const fetchPromoCodeSucceeded = createAction('booking/fetchPromoCodeSucceeded');
const fetchPromoCodeFailed = createAction('booking/fetchPromoCodeFailed');

const fetchPromoCode = (code) => (dispatch) => {
  dispatch(fetchPromoCodeStarted());

  return EcomEngineAPI.booking
    .promoCode(code)
    .then((json) => {
      dispatch(fetchPromoCodeSucceeded());
      dispatch(setBooking(json));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchPromoCodeFailed(error.message));
    });
};

const removePromoCodeStarted = createAction('booking/removePromoCodeStarted');
const removePromoCodeSucceeded = createAction(
  'booking/removePromoCodeSucceeded'
);
const removePromoCodeFailed = createAction('booking/removePromoCodeFailed');

const removePromoCode = () => (dispatch) => {
  dispatch(removePromoCodeStarted());

  return EcomEngineAPI.booking
    .promoCode('')
    .then((json) => {
      dispatch(removePromoCodeSucceeded());
      dispatch(setBooking(json));
    })
    .catch((error) => {
      trackError(error);
      dispatch(removePromoCodeFailed(error.message));
    });
};

export {
  fetchPromoCodeStarted,
  fetchPromoCodeSucceeded,
  fetchPromoCodeFailed,
  fetchPromoCode,
  removePromoCodeStarted,
  removePromoCodeSucceeded,
  removePromoCodeFailed,
  removePromoCode,
};
